import { useEffect, useState } from 'react';

import { IPaginationViewModel } from 'Types/Litium';

interface IProductListingPagePaginationProps {
    pagination: IPaginationViewModel;
    loadMoreProductsText: string;
    allProductsLoadedText: string;
    getLoadMoreProducts: (
        params: {
            name: string;
            value: string;
        }[]
    ) => void;
    isFetching: boolean;
}

export const ProductListingPagePagination = ({
    pagination,
    loadMoreProductsText,
    allProductsLoadedText,
    getLoadMoreProducts,
    isFetching,
}: IProductListingPagePaginationProps) => {
    const [currentPageIndex, setCurrentIndex] = useState(
        pagination.currentPageIndex
    );

    useEffect(() => {
        setCurrentIndex(pagination.currentPageIndex);
    }, [pagination]);

    const handleOnClick = () => {
        const nextPagesIndex = currentPageIndex + 1;
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('page', `${nextPagesIndex}`);

        const currentUrlParams = Array.from(urlParams).map(filterValue => ({
            name: filterValue[0],
            value: filterValue[1],
        }));

        const queryState = currentUrlParams
            .map(facet => `${facet.name}=${facet.value}`)
            .join('&');

        const urlWithoutQueryString =
            window.location.origin + window.location.pathname;

        getLoadMoreProducts(currentUrlParams);
        window.history.replaceState(
            {},
            '',
            `${urlWithoutQueryString}?${queryState}`
        );
        setCurrentIndex(nextPagesIndex);
    };

    return (
        <div className="mt-6 flex items-center justify-center gap-4 lg:mt-18">
            {currentPageIndex < pagination.pageCount ? (
                <button
                    onClick={() => handleOnClick()}
                    disabled={isFetching}
                    className="mb-2 min-w-full bg-cadillac px-8 py-2 font-montserrat text-xl font-medium text-white md:min-w-96"
                >
                    {loadMoreProductsText}
                </button>
            ) : (
                <p className="font-roboto text-base">{allProductsLoadedText}</p>
            )}
        </div>
    );
};
